import React from 'react';

const SNAP_POINTS = [0, 25, 50, 75, 100];
const SNAP_THRESHOLD = 4;

/** Snap value to nearest 25% detent if within threshold */
function snapToDetent(value: number): number {
  for (const point of SNAP_POINTS) {
    if (Math.abs(value - point) <= SNAP_THRESHOLD) {
      return point;
    }
  }
  return value;
}

interface PercentageSliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
  'data-testid'?: string;
}

export function PercentageSlider({
  value,
  onChange,
  disabled = false,
  className = '',
  'data-testid': dataTestId,
}: PercentageSliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(snapToDetent(Number(e.target.value)));
  };

  return (
    <div className={`relative flex-1 ${className}`}>
      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="relative z-10 w-full h-2 bg-gray-200 dark:bg-gray-600 rounded-lg appearance-none cursor-pointer accent-orange-500 disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid={dataTestId}
      />
      {/* Tick marks at 25% intervals */}
      <div className="absolute left-0 right-0 top-4 flex justify-between px-[2px] pointer-events-none">
        {SNAP_POINTS.map(point => (
          <div key={point} className="flex flex-col items-center">
            <div className="w-0.5 h-1 rounded-full bg-gray-300 dark:bg-gray-500" />
          </div>
        ))}
      </div>
    </div>
  );
}
